import { render, staticRenderFns } from "./VideoChatbox.vue?vue&type=template&id=52045807&scoped=true&"
import script from "./VideoChatbox.vue?vue&type=script&lang=js&"
export * from "./VideoChatbox.vue?vue&type=script&lang=js&"
import style0 from "./VideoChatbox.vue?vue&type=style&index=0&id=52045807&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52045807",
  null
  
)

export default component.exports